<div class="json-viewer-overlay" (click)="replaceShow = false; editElementShow = false;"
  *ngIf="replaceShow || editElementShow"></div>
<div class="container-fluid container-json-viewer">
  <div class="row">
    <div class="col-12" *ngIf="!editMode">
      <h1 class="JSON-viewer-pdf-list-title">List of uploaded PDF's</h1>
      <h4 class="JSON-viewer-pdf-list-sub-title">Click edit to convert to JSON format.</h4>
      <p-table [value]="pdfJSON" tableStyleClass="pdf-list-json-viewer">
        <ng-template pTemplate="header">
          <tr>
            <th scope="col"><span class="col-title">File Name</span></th>
            <th scope="col" class="action-width"><span class="col-title">Action</span></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
          <tr>
            <td>
              <span class="content-json-viewer">{{ rowData.fileName }}</span>
            </td>
            <td>
              <a class="pi pi-pencil mr-3 float-left" (click)="editPDF(rowData, rowIndex)" *ngIf="isEditVisa"></a>
              <a class="pi pi-trash float-left" *ngIf="isEditVisa"></a>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div class="row mt-5">
        <div class="col-12 json-viewer-footer-main">
          <div class="float-right">
            <button class="p-button-secondary json-viewer-popup-secondary mr-3 float-left" pButton pRipple type="button"
              label="Back" (click)="previousStep()" title="Back"></button>
            <button class="json-viewer-popup-primary float-left" pButton pRipple type="button" label="Next" title="Next"
              (click)="nextStep()"></button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" *ngIf="editMode">
      <div class="row">
        <div class="col-12">
          <h1 class="JSON-viewer-pdf-list-title">Update and convert to JSON</h1>
        </div>
        <div class="col-12">
          <a class="json-viewer-back" (click)="onBack()">
            <span class="pi pi-angle-left"></span>
            Back
          </a>
        </div>
        <div class="col-12">
          <div class="position-relative">
            <div class="group-list-dropdown" [ngClass]="{'d-none': !groupListShow}">
              <span class="fa fa-caret-up" aria-hidden="true"></span>
              <a (click)="onUnGroupSelected(item)" *ngFor="let item of createdGroupsArr">{{ item }}</a>
            </div>
            <p-table [value]="editablePdfJson" [reorderableColumns]="true" tableStyleClass="pdf-list-json-viewer"
              [scrollable]="true" scrollHeight="calc(100vh - 80px)">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th scope="col" class="checkbox-col-width">
                    <p-checkbox [(ngModel)]="isSelectAllMainTable" (onChange)="selectAllMainTable()"
                      [binary]="true"></p-checkbox>
                  </th>
                  <th scope="col" pReorderableColumn>
                    <span class="col-json-viewer-title">Strings</span>
                    <div class="float-right">
                      <div class="float-left" *ngIf="showGroupCountryState">
                        <a class="btn-group-checkbox" (click)="onGroupCountryState()">Group Country State</a>
                      </div>
                      <div class="float-left" *ngIf="showGroupCheckBox">
                        <a class="btn-group-checkbox" (click)="onGroupCheckbox()">Group Checkbox</a>
                      </div>
                      <div class="float-left">
                        <a (click)="onOpenRefreshAndFind()" class="find-replace-json-viewer">
                          <img src="assets/images/Icon_Find&Replace.svg" alt="Find and replace">
                        </a>
                      </div>
                      <div class="float-left">
                        <a (click)="enableGroupBtn && onGroupSelected()" [ngClass]="{'disabled': !enableGroupBtn}"
                          class="group-selected-json-viewer">
                          <img src="assets/images/Icon_Group.svg" alt="Group selected">
                        </a>
                      </div>
                      <div class="float-left position-relative">
                        <a class="group-unselected-json-viewer"
                          [ngClass]="{'disabled': !createdGroupsArr || (createdGroupsArr && createdGroupsArr.length === 0)}"
                          (click)="createdGroupsArr && createdGroupsArr.length > 0 && groupListShow = !groupListShow;">
                          <img src="assets/images/Icon_Un-Group.svg" alt="Ungroup selected">
                        </a>
                      </div>
                      <div class="float-left">
                        <a class="pi pi-trash delete-selected-json-viewer" (click)="onDeleteSelected()"></a>
                      </div>
                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
                <tr [pReorderableRow]="index" [ngClass]="{'group-row': rowData.getFieldType === 'groupTitle'}" *ngIf="!rowData.deleted &&
                (!rowData.group ||
                (rowData.group && rowData.getFieldType !== 'groupTitle' && !rowData.groupClosed) ||
                (rowData.group && rowData.getFieldType === 'groupTitle' && rowData.groupClosed))">
                  <td colspan="2" *ngIf="rowData.getFieldType === 'groupTitle'">
                    <a class="pi pi-plus maximize-group" (click)="toggleGroup(rowData.group, false)"></a>
                    <span class="group-title">{{ rowData.wholepartString }}</span>
                  </td>
                  <td class="checkbox-col-width" *ngIf="rowData.getFieldType !== 'groupTitle'">
                    <div class="group group-first"
                      *ngIf="rowData.groupElementsPlacement && rowData.groupElementsPlacement === 'group-first'"></div>
                    <div class="group group-last"
                      *ngIf="rowData.groupElementsPlacement && rowData.groupElementsPlacement === 'group-last'"></div>
                    <div class="group group-middle"
                      *ngIf="rowData.groupElementsPlacement && rowData.groupElementsPlacement === 'group-middle'"></div>
                    <div class="checkbox-holder">
                      <p-checkbox [(ngModel)]="rowData.isSelected" (onChange)="select()" [binary]="true"></p-checkbox>
                    </div>
                    <a class="pi pi-minus minimise-group" (click)="toggleGroup(rowData.group, true)"
                      *ngIf="rowData.groupElementsPlacement && (rowData.groupElementsPlacement === 'group-first' || rowData.groupElementsPlacement === 'group-last')"></a>
                  </td>
                  <td *ngIf="rowData.getFieldType !== 'groupTitle'">
                    <div class="clearfix mb-2">
                      <div class="container-edit-json-object" *ngIf="rowData.isMainEdit">
                        <textarea rows="1" [(ngModel)]="rowData.mainEditableWholePartString"
                          class="edit-element-search-popup-textarea" pInputTextarea autoResize="autoResize"></textarea>
                        <a class="pi pi-save" pTooltip="Save" tooltipPosition="left"
                          [ngClass]="{'disabled': !rowData.mainEditableWholePartString || (rowData.mainEditableWholePartString && rowData.mainEditableWholePartString.trim().length === 0)}"
                          (click)="mainElementEditSave(rowData)"></a>
                        <a class="pi pi-times-circle ml-3" pTooltip="Cancel" tooltipPosition="left"
                          (click)="rowData.isMainEdit = false;"></a>
                      </div>
                      <div class="container-json-object" *ngIf="!rowData.isMainEdit">
                        <div [ngSwitch]="rowData.getFieldType">
                          <div *ngSwitchCase="'partTitle'">
                            <span class="part-title" (dblclick)="makeEditable(rowData)">{{ rowData.wholepartString
                              }}</span>
                          </div>
                          <div *ngSwitchCase="'Textbox'">
                            <div class="form-group">
                              <label class="d-block" (dblclick)="makeEditable(rowData)">{{ rowData.wholepartString
                                }}</label>
                              <input type="text" pInputText class="json-viewer-input" placeholder="Enter" />
                            </div>
                          </div>
                          <div *ngSwitchCase="'Checkbox'">
                            <div class="form-group">
                              <label class="d-block" (dblclick)="makeEditable(rowData)"
                                *ngIf="rowData.wholepartString && rowData.wholepartString.length > 0">{{
                                rowData.wholepartString }}</label>
                              <div class="clearfix">
                                <p-checkbox class="pdf-checkbox" *ngFor="let props of rowData.properties"
                                  [label]="props.name">
                                </p-checkbox>
                              </div>
                            </div>
                          </div>
                          <div *ngSwitchCase="'Dropdown'">
                            <div class="form-group">
                              <label class="d-block" (dblclick)="makeEditable(rowData)">{{ rowData.wholepartString
                                }}</label>
                              <p-dropdown appendTo="body" styleClass="pdf-dropdown"
                                [options]="rowData.dropDownValuesList">
                              </p-dropdown>
                            </div>
                          </div>
                          <div *ngSwitchCase="'Datepicker'">
                            <div class="form-group">
                              <label class="d-block" (dblclick)="makeEditable(rowData)">{{ rowData.wholepartString
                                }}</label>
                              <p-calendar appendTo="body" styleClass="vd-pdf-datepicker" dateFormat="mm/dd/yy"
                                placeholder="MM/DD/YYYY" [showIcon]="true"
                                [monthNavigator]="true" [yearNavigator]="true" yearRange="{{fromYear}}:{{toYear}}">
                              </p-calendar>
                            </div>
                          </div>
                          <div *ngSwitchCase="'Radiobutton'">
                            <div class="form-group">
                              <label class="d-block" (dblclick)="makeEditable(rowData)"
                                *ngIf="rowData.wholepartString && rowData.wholepartString.length > 0">{{
                                rowData.wholepartString }}</label>
                              <div class="clearfix">
                                <p-radioButton class="mb-2 pdf-radiobutton"
                                  *ngFor="let props of rowData.properties; let y = index;"
                                  [(ngModel)]="rowData.radioValue" [value]="rowData.groupName + '_' + y"
                                  [label]="props.name"></p-radioButton>
                              </div>
                            </div>
                          </div>
                          <div *ngSwitchCase="'elementHeading'">
                            <span class="element-head-title" (dblclick)="makeEditable(rowData)">{{
                              rowData.wholepartString
                              }}</span>
                          </div>
                          <div *ngSwitchCase="'subHeadingTitle'">
                            <span class="sub-head-title" (dblclick)="makeEditable(rowData)">{{ rowData.wholepartString
                              }}</span>
                          </div>
                          <div *ngSwitchCase="'Questionnaire'">
                            <div class="form-group clearfix">
                              <label class="questionnaire-lbl">{{ rowData.wholepartString }}</label>
                              <p-inputSwitch styleClass="questionnaire-switch" class="float-left"></p-inputSwitch>
                            </div>
                          </div>
                          <div *ngSwitchCase="'switchWithExp'">
                            <div class="form-group clearfix">
                              <label class="questionnaire-lbl">{{ rowData.wholepartString }}</label>
                              <p-inputSwitch styleClass="questionnaire-switch" class="float-left"></p-inputSwitch>
                            </div>
                            <div class="form-group">
                              <label class="d-block">{{ rowData.textAreaLabel }}</label>
                              <textarea class="json-viewer-textarea" [disabled]="true" pInputTextarea></textarea>
                            </div>
                          </div>
                          <div *ngSwitchCase="'textarea'">
                            <div class="form-group">
                              <label class="d-block">{{ rowData.wholepartString }}</label>
                              <textarea class="json-viewer-textarea" pInputTextarea></textarea>
                            </div>
                          </div>
                          <div *ngSwitchCase="'countryState'">
                            <div class="row">
                              <div class="col-4">
                                <div class="form-group">
                                  <label class="d-block">Country</label>
                                  <p-dropdown appendTo="body" styleClass="pdf-dropdown" [options]="countryList"
                                    optionLabel="name" optionValue="code"
                                    (onChange)="handleCountryChange($event, rowData)">
                                  </p-dropdown>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="form-group">
                                  <label class="d-block">State</label>
                                  <input type="text"
                                    *ngIf="!rowData.stateList || (rowData.stateList && rowData.stateList.length === 0)"
                                    pInputText class="json-viewer-input" placeholder="Enter" />
                                  <p-dropdown appendTo="body" *ngIf="rowData.stateList && rowData.stateList.length > 0"
                                    optionLabel="stateProvinceName" optionValue="stateProvinceCode"
                                    styleClass="pdf-dropdown" [options]="rowData.stateList">
                                  </p-dropdown>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div *ngSwitchDefault>
                            <span style="font-weight:600;color:red;">Default</span> {{
                            rowData.getFieldType }}
                          </div>
                        </div>
                      </div>
                      <div class="element-type-div">
                        <p-dropdown appendTo="body" [options]="elementTypeArr" [(ngModel)]="rowData.defineAs"
                          class="d-block mt-1" optionLabel="name"
                          (onChange)="onDefinitionChange($event, rowData, index)" optionValue="value"></p-dropdown>
                      </div>
                      <div class="speed-dial">
                        <a class="fa fa-cog" [ngClass]="{'speed-dial-active': rowData.speedDialClicked}"
                          (click)="onSpeedDialClick(rowData, !rowData.speedDialClicked)"></a>
                        <div class="speed-dial-content"
                          [ngClass]="{'speed-dial-content-active': rowData.speedDialClicked}">
                          <a class="pi pi-pencil" pTooltip="Edit" *ngIf="rowData.getFieldType !== 'countryState'"
                            tooltipPosition="left" (click)="onRowEdit(rowData, index)"></a>
                          <a class="pi pi-copy" pTooltip="Duplicate" tooltipPosition="left"
                            (click)="onRowDuplicate(rowData, index)"></a>
                          <a class="pi pi-trash" pTooltip="Delete" tooltipPosition="left"
                            (click)="onRowDelete(rowData)"></a>
                        </div>
                      </div>
                      <span class="pi pi-arrows-alt" pReorderableRowHandle></span>
                    </div>
                    <div>
                      <p class="font-italic mb-0 element-id-txt"><span class="font-weight-bold">ID : </span>{{
                        rowData.elementId }}</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <div class="col-12 json-viewer-footer-main">
          <button class="json-viewer-popup-primary mr-3" pButton pRipple type="button" label="Save" title="Save"
            (click)="onJSONEditSave()"></button>
          <button class="p-button-secondary json-viewer-popup-secondary" pButton pRipple type="button" label="Back"
            (click)="onBack()" title="Back"></button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog [baseZIndex]="10000"></p-confirmDialog>
<div class="json-viewer-popup refresh-replace-popup" *ngIf="replaceShow">
  <div class="json-viewer-header-row">
    <div class="json-viewer-header-col">
      <div class="row">
        <div class="col-10">
          <span class="json-viewer-header-title">Search what you are looking for...</span>
        </div>
        <div class="col-2">
          <a class="pi pi-times json-viewer-popup-close" (click)="closeSearchPopup()"></a>
        </div>
      </div>
    </div>
  </div>
  <div class="row json-viewer-content scrollable-popup">
    <div class="col-12">
      <span class="json-viewer-search-sub-titile">Type the word or sentences</span>
    </div>
    <div class="col-12">
      <input type="text" class="json-viewer-search-text" [(ngModel)]="searchString" />
      <button class="json-viewer-popup-primary ml-3" pButton pRipple type="button" label="Find" title="Find"
        [ngClass]="{'disabled': searchString === ''}" (click)="onSearch()"></button>
    </div>
    <div class="col-12 my-3" *ngIf="replaceSearchClicked">
      <div class="json-viewer-matches-box">
        <span class="json-viewer-search-sub-titile">Matches ({{ filteredList ? filteredList.length : '0' }})</span>
      </div>
    </div>
    <div *ngIf="filteredList?.length > 0">
      <div class="col-12">
        <span class="json-viewer-search-sub-titile">Do you wish to replace all the matches with any other word or
          sentences</span>
      </div>
      <div class="col-12">
        <input type="text" class="json-viewer-replace-text" [(ngModel)]="replaceString" />
        <button class="json-viewer-popup-primary ml-3" [ngClass]="{'disabled': !enableReplaceBtn}" pButton pRipple
          type="button" label="Replace Selected" title="Replace Selected" (click)="onReplace()"></button>
      </div>
      <div class="col-12 mt-3">
        <p-table [value]="filteredList" tableStyleClass="pdf-list-json-viewer" [scrollable]="true"
          scrollHeight="calc(100vh - 250px)">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th scope="col" class="checkbox-col-width in-search-popup">
                <p-checkbox [(ngModel)]="isSelectAllSearchTable" (onChange)="selectAllSearchTable()"
                  [binary]="true"></p-checkbox>
              </th>
              <th scope="col">
                <span class="col-json-viewer-title">Strings</span>
                <div class="float-right">
                  <div class="float-left">
                    <a class="delete-selected-json-viewer-replace" (click)="onDeleteSelected('searchTable')">
                      <span class="pi pi-trash"></span>
                      <span class="delete-selected-json-viewer-replace-text">Delete
                        Selected</span>
                    </a>
                  </div>
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
            <tr *ngIf="!rowData.deleted && rowData.getFieldType !== 'groupTitle'">
              <td class="checkbox-col-width in-search-popup">
                <div class="checkbox-holder">
                  <p-checkbox [(ngModel)]="rowData.isSelected" (onChange)="selectedSearchResult()"
                    [binary]="true"></p-checkbox>
                </div>
              </td>
              <td>
                <div class="container-edit-object" *ngIf="rowData.editSearchElementShow">
                  <textarea rows="1" [(ngModel)]="rowData.editableWholePartString"
                    class="edit-element-search-popup-textarea" pInputTextarea autoResize="autoResize"></textarea>
                </div>
                <div class="container-search-object" *ngIf="!rowData.editSearchElementShow">
                  <div [ngSwitch]="rowData.getFieldType">
                    <div *ngSwitchCase="'partTitle'">
                      <span class="part-title"
                        [innerHTML]="rowData.highlightString ? rowData.highlightString : rowData.wholepartString"></span>
                    </div>
                    <div *ngSwitchCase="'Textbox'">
                      <div class="form-group">
                        <label class="d-block"
                          [innerHTML]="rowData.highlightString ? rowData.highlightString : rowData.wholepartString"></label>
                        <input type="text" pInputText class="json-viewer-input" placeholder="Enter" />
                      </div>
                    </div>
                    <div *ngSwitchCase="'Checkbox'">
                      <div class="form-group">
                        <label class="d-block" *ngIf="rowData.wholepartString && rowData.wholepartString.length > 0"
                          [innerHTML]="rowData.highlightString ? rowData.highlightString : rowData.wholepartString"></label>
                        <div class="clearfix">
                          <p-checkbox class="pdf-checkbox" *ngFor="let props of rowData.properties"
                            [label]="props.name">
                          </p-checkbox>
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchCase="'Dropdown'">
                      <div class="form-group">
                        <label class="d-block"
                          [innerHTML]="rowData.highlightString ? rowData.highlightString : rowData.wholepartString"></label>
                        <p-dropdown appendTo="body" styleClass="pdf-dropdown" [options]="rowData.dropDownValuesList">
                        </p-dropdown>
                      </div>
                    </div>
                    <div *ngSwitchCase="'Datepicker'">
                      <div class="form-group">
                        <label class="d-block"
                          [innerHTML]="rowData.highlightString ? rowData.highlightString : rowData.wholepartString"></label>
                        <p-calendar appendTo="body" styleClass="vd-pdf-datepicker" dateFormat="mm/dd/yy"
                          placeholder="MM/DD/YYYY" [showIcon]="true" [monthNavigator]="true"
                          [yearNavigator]="true" yearRange="{{fromYear}}:{{toYear}}">
                        </p-calendar>
                      </div>
                    </div>
                    <div *ngSwitchCase="'Radiobutton'">
                      <div class="form-group">
                        <label class="d-block" *ngIf="rowData.wholepartString && rowData.wholepartString.length > 0"
                          [innerHTML]="rowData.highlightString ? rowData.highlightString : rowData.wholepartString"></label>
                        <div class="clearfix">
                          <p-radioButton class="mb-2 pdf-radiobutton"
                            *ngFor="let props of rowData.properties; let y = index;" [(ngModel)]="rowData.radioValue"
                            [value]="rowData.groupName + '_' + y" [label]="props.name"></p-radioButton>
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchCase="'elementHeading'">
                      <span class="element-head-title"
                        [innerHTML]="rowData.highlightString ? rowData.highlightString : rowData.wholepartString"></span>
                    </div>
                    <div *ngSwitchCase="'subHeadingTitle'">
                      <span class="sub-head-title"
                        [innerHTML]="rowData.highlightString ? rowData.highlightString : rowData.wholepartString"></span>
                    </div>
                    <div *ngSwitchCase="'Questionnaire'">
                      <div class="form-group clearfix">
                        <label class="questionnaire-lbl">{{
                          rowData.wholepartString }}</label>
                        <p-inputSwitch styleClass="questionnaire-switch" class="float-left"></p-inputSwitch>
                      </div>
                    </div>
                    <div *ngSwitchCase="'switchWithExp'">
                      <div class="form-group clearfix">
                        <label class="questionnaire-lbl">{{ rowData.wholepartString }}</label>
                        <p-inputSwitch styleClass="questionnaire-switch" class="float-left"></p-inputSwitch>
                      </div>
                      <div class="form-group">
                        <label class="d-block">{{ rowData.textAreaLabel }}</label>
                        <textarea class="json-viewer-textarea" [disabled]="true" pInputTextarea></textarea>
                      </div>
                    </div>
                    <div *ngSwitchCase="'textarea'">
                      <div class="form-group">
                        <label class="d-block">{{ rowData.wholepartString }}</label>
                        <textarea class="json-viewer-textarea" pInputTextarea></textarea>
                      </div>
                    </div>
                    <div *ngSwitchCase="'countryState'">
                      <div class="row">
                        <div class="col-4">
                          <div class="form-group">
                            <label class="d-block">Country</label>
                            <p-dropdown appendTo="body" styleClass="pdf-dropdown" [options]="countryList"
                              optionLabel="name" optionValue="code" (onChange)="handleCountryChange($event, rowData)">
                            </p-dropdown>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="form-group">
                            <label class="d-block">State</label>
                            <input type="text"
                              *ngIf="!rowData.stateList || (rowData.stateList && rowData.stateList.length === 0)"
                              pInputText class="json-viewer-input" placeholder="Enter" />
                            <p-dropdown appendTo="body" *ngIf="rowData.stateList && rowData.stateList.length > 0"
                              optionLabel="stateProvinceName" optionValue="stateProvinceCode" styleClass="pdf-dropdown"
                              [options]="rowData.stateList">
                            </p-dropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchDefault><span style="font-weight:600;color:red;">Default</span> {{
                      rowData.getFieldType }}</div>
                  </div>
                </div>
                <div>
                  <a class="pi pi-save" pTooltip="Save" tooltipPosition="left"
                    [ngClass]="{'d-none': !rowData.editSearchElementShow, 'disabled': !rowData.editableWholePartString || (rowData.editableWholePartString && rowData.editableWholePartString.trim().length === 0)}"
                    (click)="searchPopupElementEditSave(rowData)"></a>
                  <a class="pi pi-times-circle ml-3" pTooltip="Cancel" tooltipPosition="left"
                    [ngClass]="{'d-none': !rowData.editSearchElementShow}"
                    (click)="rowData.editSearchElementShow = false;"></a>
                  <a class="pi pi-pencil" [ngClass]="{'d-none': rowData.editSearchElementShow}" pTooltip="Edit"
                    tooltipPosition="left" (click)="onRowSearchEdit(rowData)"></a>
                  <a class="pi pi-trash ml-3" pTooltip="Delete" tooltipPosition="left"
                    (click)="onRowDelete(rowData)"></a>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
  <div class="row json-viewer-footer">
    <div class="col-12">
      <button class="json-viewer-popup-primary mr-3" pButton pRipple type="button" label="Save" title="Save"
        (click)="onReplaceSave()"></button>
      <button class="p-button-secondary json-viewer-popup-secondary" pButton pRipple type="button" label="Back"
        title="Back" (click)="closeSearchPopup()"></button>
    </div>
  </div>
</div>
<div class="json-viewer-popup edit-element-popup" *ngIf="editElementShow">
  <div class="json-viewer-header-row">
    <div class="json-viewer-header-col">
      <div class="row">
        <div class="col-10">
          <span class="json-viewer-header-title">Edit the string</span>
        </div>
        <div class="col-2">
          <a class="pi pi-times json-viewer-popup-close" (click)="onRowEditClose()"></a>
        </div>
      </div>
    </div>
  </div>
  <div class="row json-viewer-content">
    <div class="col-12">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label class="d-block">Update the content in the string</label>
            <textarea rows="1" [(ngModel)]="editObj.wholepartString" class="edit-element-popup-textarea" pInputTextarea
              autoResize="autoResize"></textarea>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="editObj.defineAs === 'element'">
        <div class="col-12">
          <h1 class="json-viewer-content-sub-header">Add Component</h1>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label class="d-block">Component</label>
            <p-dropdown appendTo="body" styleClass="json-viewer-content-dropdown" [options]="elementList"
              (onChange)="onFieldTypeChange()" [(ngModel)]="editObj.getFieldType" optionLabel="name" optionValue="code">
            </p-dropdown>
          </div>
        </div>
        <div class="w-100"></div>
        <div class="col-12" *ngIf="['Dropdown','Checkbox', 'Radiobutton'].includes(editObj.getFieldType)">
          <div class="container-fluid json-viewer-element-settings">
            <div class="options-list-view">
              <span class="options-list-view-title">Customise the component</span>
              <div class="options-list-items clearfix" *ngFor="let item of editObj.properties; let i = index;">
                <span class="options-list-items-text" [ngClass]="{'d-none': item.isEdit}">{{
                  item.name }}</span>
                <textarea rows="1" cols="30" [(ngModel)]="item.name" class="options-list-items-textarea" pInputTextarea
                  autoResize="autoResize" [ngClass]="{'d-none': !item.isEdit}"></textarea>
                <div class="float-right">
                  <div class="options-list-items-reorder-holder">
                    <a class="options-list-items-edit pi pi-arrow-up" (click)="onReOrderItemEditOption('up', i)"
                      [ngClass]="{'d-none': item.isEdit, 'invisible': i === 0}"></a>
                    <a class="options-list-items-edit pi pi-arrow-down" (click)="onReOrderItemEditOption('down', i)"
                      [ngClass]="{'d-none': item.isEdit, 'invisible': i === (editObj.properties.length - 1)}"></a>
                  </div>
                  <a class="options-list-items-edit pi pi-save"
                    [ngClass]="{'d-none': !item.isEdit, 'disabled': !item.name || (item.name && item.name.trim().length === 0)}"
                    (click)="item.name && item.name.trim().length > 0 && item.isEdit = false;"></a>
                  <a class="options-list-items-edit pi pi-times-circle" (click)="onOptionItemEditClose(item)"
                    [ngClass]="{'d-none': !item.isEdit}"></a>
                  <a class="options-list-items-edit pi pi-pencil" [ngClass]="{'d-none': item.isEdit}"
                    (click)="onOptionItemEdit(item)"></a>
                  <a class="options-list-items-delete pi pi-trash" [ngClass]="{'d-none': item.isEdit}"
                    (click)="onOptionItemDelete(i)"></a>
                </div>
              </div>
              <div class="options-list-items-add-container clearfix">
                <textarea rows="1" cols="30" [(ngModel)]="newOption" class="options-list-items-add-textarea"
                  pInputTextarea autoResize="autoResize"></textarea>
                <a class="options-list-items-add pi pi-plus"
                  [ngClass]="{'disabled': !newOption || (newOption && newOption.trim().length === 0)}"
                  (click)="newOption && newOption.trim().length > 0 && addOptionItem()"></a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12" *ngIf="['switchWithExp'].includes(editObj.getFieldType)">
          <div class="container-fluid json-viewer-element-settings">
            <div class="options-list-view">
              <span class="options-list-view-title">Customise the component</span>
              <div class="form-group">
                <label class="d-block required">Enter Text Area label</label>
                <input type="text" [(ngModel)]="editObj.textAreaLabel" pInputText class="w-100" placeholder="Enter" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row json-viewer-footer">
    <div class="col-12">
      <button class="json-viewer-popup-primary mr-3" pButton pRipple type="button" label="Save" title="Save"
        [disabled]="['switchWithExp'].includes(editObj.getFieldType) && (!editObj.textAreaLabel || (editObj.textAreaLabel && editObj.textAreaLabel.trim() === ''))"
        (click)="onRowEditSave()"></button>
      <button class="p-button-secondary json-viewer-popup-secondary" pButton pRipple type="button" label="Back"
        (click)="onRowEditClose()" title="Back"></button>
    </div>
  </div>
</div>
<div class="json-viewer-popup edit-element-popup" *ngIf="showGroupCountryStatePopup">
  <div class="json-viewer-header-row">
    <div class="json-viewer-header-col">
      <div class="row">
        <div class="col-10">
          <span class="json-viewer-header-title">Create Country State Control</span>
        </div>
        <div class="col-2">
          <a class="pi pi-times json-viewer-popup-close" (click)="onCloseCountryState()"></a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 mt-3">
    <p-table [value]="countryStateList" tableStyleClass="pdf-list-json-viewer" [scrollable]="true"
      scrollHeight="calc(100vh - 250px)">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col">
            <span class="col-json-viewer-title">Country State List</span>
            <span class="col-json-viewer-title float-right">Type</span>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
        <tr *ngIf="!rowData.deleted && rowData.getFieldType !== 'groupTitle'">
          <td>
            <div class="container-search-object container-contry-state-object" *ngIf="!rowData.editSearchElementShow">
              <div [ngSwitch]="rowData.getFieldType">
                <div *ngSwitchCase="'partTitle'">
                  <span class="part-title"
                    [innerHTML]="rowData.highlightString ? rowData.highlightString : rowData.wholepartString"></span>
                </div>
                <div *ngSwitchCase="'Textbox'">
                  <div class="form-group">
                    <label class="d-block"
                      [innerHTML]="rowData.highlightString ? rowData.highlightString : rowData.wholepartString"></label>
                    <input type="text" pInputText class="json-viewer-input" placeholder="Enter" />
                  </div>
                </div>
                <div *ngSwitchCase="'Checkbox'">
                  <div class="form-group">
                    <label class="d-block" *ngIf="rowData.wholepartString && rowData.wholepartString.length > 0"
                      [innerHTML]="rowData.highlightString ? rowData.highlightString : rowData.wholepartString"></label>
                    <div class="clearfix">
                      <p-checkbox class="pdf-checkbox" *ngFor="let props of rowData.properties" [label]="props.name">
                      </p-checkbox>
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="'Dropdown'">
                  <div class="form-group">
                    <label class="d-block"
                      [innerHTML]="rowData.highlightString ? rowData.highlightString : rowData.wholepartString"></label>
                    <p-dropdown appendTo="body" styleClass="pdf-dropdown" [options]="rowData.dropDownValuesList">
                    </p-dropdown>
                  </div>
                </div>
                <div *ngSwitchCase="'Datepicker'">
                  <div class="form-group">
                    <label class="d-block"
                      [innerHTML]="rowData.highlightString ? rowData.highlightString : rowData.wholepartString"></label>
                    <p-calendar appendTo="body" styleClass="vd-pdf-datepicker" dateFormat="mm/dd/yy"
                      placeholder="MM/DD/YYYY" [showIcon]="true" [monthNavigator]="true"
                      [yearNavigator]="true" yearRange="{{fromYear}}:{{toYear}}">
                    </p-calendar>
                  </div>
                </div>
                <div *ngSwitchCase="'Radiobutton'">
                  <div class="form-group">
                    <label class="d-block" *ngIf="rowData.wholepartString && rowData.wholepartString.length > 0"
                      [innerHTML]="rowData.highlightString ? rowData.highlightString : rowData.wholepartString"></label>
                    <div class="clearfix">
                      <p-radioButton class="mb-2 pdf-radiobutton"
                        *ngFor="let props of rowData.properties; let y = index;" [(ngModel)]="rowData.radioValue"
                        [value]="rowData.groupName + '_' + y" [label]="props.name"></p-radioButton>
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="'elementHeading'">
                  <span class="element-head-title"
                    [innerHTML]="rowData.highlightString ? rowData.highlightString : rowData.wholepartString"></span>
                </div>
                <div *ngSwitchCase="'subHeadingTitle'">
                  <span class="sub-head-title"
                    [innerHTML]="rowData.highlightString ? rowData.highlightString : rowData.wholepartString"></span>
                </div>
                <div *ngSwitchCase="'Questionnaire'">
                  <div class="form-group clearfix">
                    <label class="questionnaire-lbl">{{
                      rowData.wholepartString }}</label>
                    <p-inputSwitch styleClass="questionnaire-switch" class="float-left"></p-inputSwitch>
                  </div>
                </div>
                <div *ngSwitchCase="'switchWithExp'">
                  <div class="form-group clearfix">
                    <label class="questionnaire-lbl">{{ rowData.wholepartString }}</label>
                    <p-inputSwitch styleClass="questionnaire-switch" class="float-left"></p-inputSwitch>
                  </div>
                  <div class="form-group">
                    <label class="d-block">{{ rowData.textAreaLabel }}</label>
                    <textarea class="json-viewer-textarea" [disabled]="true" pInputTextarea></textarea>
                  </div>
                </div>
                <div *ngSwitchCase="'textarea'">
                  <div class="form-group">
                    <label class="d-block">{{ rowData.wholepartString }}</label>
                    <textarea class="json-viewer-textarea" pInputTextarea></textarea>
                  </div>
                </div>
                <div *ngSwitchCase="'countryState'">
                  <div class="row">
                    <div class="col-4">
                      <div class="form-group">
                        <label class="d-block">Country</label>
                        <p-dropdown appendTo="body" styleClass="pdf-dropdown" [options]="countryList" optionLabel="name"
                          optionValue="code" (onChange)="handleCountryChange($event, rowData)">
                        </p-dropdown>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="form-group">
                        <label class="d-block">State</label>
                        <input type="text"
                          *ngIf="!rowData.stateList || (rowData.stateList && rowData.stateList.length === 0)" pInputText
                          class="json-viewer-input" placeholder="Enter" />
                        <p-dropdown appendTo="body" *ngIf="rowData.stateList && rowData.stateList.length > 0"
                          optionLabel="stateProvinceName" optionValue="stateProvinceCode" styleClass="pdf-dropdown"
                          [options]="rowData.stateList">
                        </p-dropdown>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngSwitchDefault><span style="font-weight:600;color:red;">Default</span> {{
                  rowData.getFieldType }}</div>
              </div>
            </div>
            <div>
              <ng-template [ngIf]="index === 0">
                <div class="field-radiobutton">
                  <p-radioButton name="countryStateRadioBtnGroup" [value]="true" [(ngModel)]="rowData.isCountry"
                    (onClick)="onCountryStateSelection()"></p-radioButton>
                  <label>Country</label>
                </div>
                <div class="field-radiobutton">
                  <p-radioButton name="countryStateRadioBtnGroup" [value]="false" [(ngModel)]="rowData.isCountry"
                    (onClick)="onCountryStateSelection()"></p-radioButton>
                  <label>State</label>
                </div>
              </ng-template>
              <ng-template [ngIf]="index === 1">
                <span class="contry-state-type-text">{{ rowData.isCountry ? 'Country': 'State' }}</span>
              </ng-template>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="row json-viewer-footer">
    <div class="col-12">
      <button class="json-viewer-popup-primary mr-3" pButton pRipple type="button" label="Save" title="Save"
        (click)="onCreateCountryState()"></button>
      <button class="p-button-secondary json-viewer-popup-secondary" pButton pRipple type="button" label="Back"
        (click)="onCloseCountryState()" title="Back"></button>
    </div>
  </div>
</div>
